const BankCreditReport = () =>
  import(
    /* webpackChunkName: "financial-commercial-banking" */ '@/pages/financial/commercial-banking/bank-credit/index.vue'
  )

const CreateBankCredit = () =>
  import(
    /* webpackChunkName: "financial-commercial-banking" */ '@/pages/financial/commercial-banking/bank-credit/create.vue'
  )

export default {
  path: 'bank-credit',
  meta: {
    label: 'bankCredit',
    auth: true
  },
  component: {
    name: 'BankCredit',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CreateBankCredit',
      path: 'create',
      meta: {
        label: 'report'
      },
      component: CreateBankCredit
    },
    {
      name: 'BankCreditReport',
      path: '',
      meta: {
        label: 'report'
      },
      component: BankCreditReport
    }
  ]
}
